<template>
    <header class="site-header">

        <button v-on:click="toggleMenu" class="hamburger hamburger--htla">
            <span>toggle menu</span>
        </button>

        <nav class="navbar navbar-expand-lg">
            <a href="#" class="navbar-brand">
                {{ _.setting('APP_NAME') }}
            </a>
            <!-- <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#main-nav" aria-controls="main-nav" aria-expanded="false" aria-label="Toggle navigation"> -->
            <!--     <span class="navbar-toggler-icon"></span> -->
            <!-- </button> -->
            <div id="main-nav" class="d-flex ml-auto collapse_ navbar-collapse_">
                <ul class="navbar-nav flex-row">
                    <li class="nav-item active">
                        <a class="nav-link" href="https://www.72dpi.co.nz/contact-us/" target="_blank"><i class="material-icons">help_outline</i><span class="d-none d-md-inline"> Support</span></a>
                    </li>
                    <!-- <li class="nav-item"> -->
                        <!--   <a class="nav-link" href="#"><i class="material-icons">notifications</i></a> -->
                        <!-- <b-popover target="notification" -->
                            <!-- triggers="click blur" -->
                            <!-- placement="bottom" -->
                            <!-- ref="popover"> -->
                            <!-- <div> -->
                                <!-- <b-alert show v-if="notifications.length == 0" variant="secondary"> -->
                                    <!-- You don't have any notification -->
                                    <!-- </b-alert> -->
                                <!-- <b-alert -->
                                    <!-- v-for="notification in notifications" -->
                                    <!-- :key="generateTimestamp()" -->
                                    <!-- :variant="notification.type == 'message' ? 'success' : 'warning'" -->
                                    <!-- show> -->
                                    <!-- {{notification.message}} -->
                                    <!-- </b-alert> -->
                                <!-- </div> -->
                            <!-- </b-popover> -->
                        <!-- </li> -->
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <span class="d-none d-sm-inline">{{ user.name }}</span>
                            <i class="material-icons d-sm-none">account_circle</i>
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <a class="dropdown-item" :href="userLink">Edit profile</a>
                            <a class="dropdown-item" :href="userLink + '#password'">Change password</a>
                            <a class="dropdown-item" v-on:click="logout">Logout</a>
                        </div>
                    </li>

                    <li v-if="!_.isEmpty(connectionList)" class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{ connection.name }}
                        </a>
                        <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                            <a v-for="connection in connectionList" class="dropdown-item" :href="connection.link + '#' + endpoint">{{ connection.name }}</a>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="/" target="_blank"><span class="d-none d-md-inline">Live site</span> <i class="material-icons">arrow_forward</i></a>
                    </li>
                </ul>
            </div>
        </nav>

    </header><!--.site-header-->
</template>
<script>
import Vue from 'vue';
import Vuex from 'vuex';

export default {
    data() {
        return {
            loading: false,
        }
    },

    components: {

    },

    mounted() {
        console.log('Component mounted.')
    },

    computed: {
        ...Vuex.mapGetters({
            user: 'user',
            notifications: 'notifications',
            currentConnection: 'currentConnection',
            connections: 'connections',
            resourceParams: 'resourceParams',
        }),

        connectionList() {
            if (_.isFunction(this.connections)) {
                return this.connections.call(this);
            }

            return this.connections;
        },

        connection() {
            return _.find(this.connectionList, (c) => c.id == this.currentConnection);
        },

        userLink() {
            return '#/user/' + this.user.id;
        },

        endpoint() {
            return _.get(this.resourceParams, 'endpoint', '');
        },
    },

    methods: {
        ...Vuex.mapActions([

        ]),

        toggleMenu() {
            document.body.classList.toggle('sidebar-show');
        },

        logout(e) {
            e.preventDefault();
            this.helpers('api').logout()
                .finally(() => window.location.href = '/admin/login');
        },

        generateTimestamp() {
            return Math.random();
        }
    }
}
</script>



// WEBPACK FOOTER //
// seventytwo/72cms-ui/src/components/HeaderComponent.vue